import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SignalsPage from './pages/SignalsPage';

import FavoritesPage from './pages/FavoritesPage';
import TradingPage from './pages/TradingPage';
import DocsPage from './pages/DocsPage';
import AdminPage from './pages/AdminPage';
import Layout from './components/Layout';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ErrorBoundary from './components/ErrorBoundary';

function ProtectedRoute({ children }) {
  const { user, initializing } = useAuth();
  if (initializing) return <div style={{ minHeight: '100vh', background: '#080c14', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, initializing } = useAuth();
  if (initializing) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public pages */}
      <Route path="/" element={<PublicRoute><HomePage /></PublicRoute>} />
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Protected app — every page wrapped in its own ErrorBoundary so a
          render crash on one route can't blank the whole shell. */}
      <Route path="/dashboard" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index            element={<ErrorBoundary routeLabel="dashboard"><DashboardPage /></ErrorBoundary>} />
        <Route path="signals"   element={<ErrorBoundary routeLabel="signals"><SignalsPage /></ErrorBoundary>} />
        <Route path="favorites" element={<ErrorBoundary routeLabel="favorites"><FavoritesPage /></ErrorBoundary>} />
        <Route path="trading"   element={<ErrorBoundary routeLabel="trading"><TradingPage /></ErrorBoundary>} />
        <Route path="docs"      element={<ErrorBoundary routeLabel="docs"><DocsPage /></ErrorBoundary>} />
        <Route path="admin"     element={<ErrorBoundary routeLabel="admin"><AdminPage /></ErrorBoundary>} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

import { ExchangeProvider } from './context/ExchangeContext';
import { ToastProvider } from './components/ui/Toast';

export default function App() {
  return (
    <AuthProvider>
      <ExchangeProvider>
        <ToastProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ToastProvider>
      </ExchangeProvider>
    </AuthProvider>
  );
}
